import React, { useContext, useMemo } from "react";
import SelectionItem from "../../SelectionItem";
import ImgAdentyTopImplant from "./images/adentyTopImplant.png";
import ImgAdentyTopGum from "./images/adentyTopGum.png";
import ImgAdentyBottomImplant from "./images/adentyBottomImplant.png";
import ImgAdentyBottomGum from "./images/adentyBottomGum.png";
import ImgAdentyBothImplant from "./images/adentyBothImplant.png";
import ImgAdentyBothGum from "./images/adentyBothGum.png";
import "./index.scss";
import { toothTypes } from "../../../FormulaGenerator/Formula/tooth";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const AdentyFullType = ({
  selectStep,
  stepId
}) => {
  const {
    _t
  } = useTranslation();
  const {
    toggleBottomBarInfo
  } = useContext(StepContext);
  const availableTypes = useMemo(() => {
    return {
      PSP_ET_e1_e2_adenty_adentyTop: [{
        key: "adentyTopImplant",
        img: ImgAdentyTopImplant,
        name: _t("Протез на имплантах"),
        description: _t("Применяется в большинстве случаев. Самый надежный и высоко эстетический способ протезирования беззубых челюстей...")
      }, {
        key: "adentyTopGum",
        img: ImgAdentyTopGum,
        name: _t("Съемный протез"),
        description: _t("Самая простая, достаточно эстетическая методика, но не самая комфортная и безопасная для использования. Используется для временного протезирования.")
      }],
      PSP_ET_e1_e2_adenty_adentyBottom: [{
        key: "adentyBottomImplant",
        img: ImgAdentyBottomImplant,
        name: _t("Протез на имплантах"),
        description: _t("Применяется в большинстве случаев. Самый надежный и высоко эстетический способ протезирования беззубых челюстей...")
      }, {
        key: "adentyBottomGum",
        img: ImgAdentyBottomGum,
        name: _t("Съемный протез"),
        description: _t("Самая простая, достаточно эстетическая методика, но не самая комфортная и безопасная для использования. Используется для временного протезирования.")
      }],
      PSP_ET_e1_e2_adenty_adentyBoth: [{
        key: "adentyBothImplant",
        img: ImgAdentyBothImplant,
        name: _t("Протез на имплантах"),
        description: _t("Применяется в большинстве случаев. Самый надежный и высоко эстетический способ протезирования беззубых челюстей...")
      }, {
        key: "adentyBothGum",
        img: ImgAdentyBothGum,
        name: _t("Съемный протез"),
        description: _t("Самая простая, достаточно эстетическая методика, но не самая комфортная и безопасная для использования. Используется для временного протезирования.")
      }]
    };
  }, [_t]);

  function setStep(key) {
    let updatedData = {};

    switch (key) {
      case "adentyTopGum":
        updatedData = {
          tooth: [...toothTypes.filter(el => el.position === "top").map(el => ({
            name: el.name,
            toothElementsActive: ["prostheticsTooth"]
          })), ...toothTypes.filter(el => el.position === "bottom").map(el => ({
            name: el.name,
            toothElementsActive: ["healthyTooth"]
          }))],
          prosthesis: ["totalTop"]
        };
        break;

      case "adentyBottomGum":
        updatedData = {
          tooth: [...toothTypes.filter(el => el.position === "top").map(el => ({
            name: el.name,
            toothElementsActive: ["healthyTooth"]
          })), ...toothTypes.filter(el => el.position === "bottom").map(el => ({
            name: el.name,
            toothElementsActive: ["prostheticsTooth"]
          }))],
          prosthesis: ["totalBottom"]
        };
        break;

      case "adentyBothGum":
        updatedData = {
          tooth: [...toothTypes.filter(el => el.position === "top").map(el => ({
            name: el.name,
            toothElementsActive: ["prostheticsTooth"]
          })), ...toothTypes.filter(el => el.position === "bottom").map(el => ({
            name: el.name,
            toothElementsActive: ["prostheticsTooth"]
          }))],
          prosthesis: ["totalTop", "totalBottom"]
        };
        break;

      case "adentyTopImplant":
        updatedData = {
          tooth: [...toothTypes.filter(el => el.position === "top").map(el => ({
            name: el.name,
            toothElementsActive: ["emptyTooth"]
          })), ...toothTypes.filter(el => el.position === "bottom").map(el => ({
            name: el.name,
            toothElementsActive: ["healthyTooth"]
          }))]
        };
        break;

      case "adentyBottomImplant":
        updatedData = {
          tooth: [...toothTypes.filter(el => el.position === "top").map(el => ({
            name: el.name,
            toothElementsActive: ["healthyTooth"]
          })), ...toothTypes.filter(el => el.position === "bottom").map(el => ({
            name: el.name,
            toothElementsActive: ["emptyTooth"]
          }))]
        };
        break;

      case "adentyBothImplant":
        updatedData = {
          tooth: [...toothTypes.map(el => ({
            name: el.name,
            toothElementsActive: ["emptyTooth"]
          }))]
        };
        break;

      default:
        break;
    }

    selectStep(key, updatedData);
  }

  function openBottomBar(type) {
    toggleBottomBarInfo(true, type);
  }

  const types = useMemo(() => {
    return availableTypes[stepId] || [];
  }, [availableTypes, stepId]);
  return /*#__PURE__*/React.createElement("div", {
    className: "adentyFullType"
  }, /*#__PURE__*/React.createElement("div", {
    className: "adentyFullType-list"
  }, types && types.map(el => /*#__PURE__*/React.createElement(SelectionItem, {
    key: el.key,
    itemKey: el.key,
    isSelected: false,
    select: () => {
      setStep(el.key);
    },
    preview: el.img,
    outerTitle: el.name,
    outerDescription: el.description,
    aboutClick: () => openBottomBar(el.key)
  }))));
};

export default AdentyFullType;